import { AppConfig } from "../AppConfig";

export const ApiConfig = {
  ROOT_URL: AppConfig?.APIBaseUrl ?? "",
  REST_URIS: {
    auth: {
      login: "auth/login",
      register: "auth/register",
      forgotpassword: "auth/forgotpassword",
      resetPassword: "auth/resetpassword",
    },
    user: {
      fetchAll: "users",
      getById: (id: string) => `users/${id}`,
      create: "users/create",
      update: (id: string) => `users/${id}/update`,
      delete: (id: string) => `users/${id}/del`,
      getUserAddress: (id: string) => `users/${id}/address`,
      saveProfile: (id: string) => `users/${id}/saveprofile`,
      changePassword: `users/changemypassword`,
      changePasswordByUserId: `users/changepasswordbyuserid`,
    },
    product: {
      allProducts: `Products`,
      productById: (id: number) => `Products/${id}`,
      createProduct: "Products/create",
      updateProduct: (id: number) => `Products/${id}/update`,
      deleteProduct: (id: number) => `Products/${id}/del`,
      hideProduct: (id: number) => `Products/${id}/hide`,
      allCategories: "Products/Categories",
      allAddOns: (productId: number) => `Products/addons/${productId}`,
      updateProductAddons: (productId: number) =>
        `Products/${productId}/updateAddons`,
      prodHub: "prodHub",
    },
    addOn: {
      fetchAddOns: "AddOns",
      create: "AddOns/create",
      update: (id: number) => `AddOns/${id}/update`,
      delete: (id: number) => `AddOns/${id}/del`,
    },
    addOnOption: {
      fetchAddOnOptions: "AddOnOptions",
      create: "AddOnOptions/create",
      update: (id: number) => `AddOnOptions/${id}/update`,
      delete: (id: number) => `AddOnOptions/${id}/del`,
    },
    order: {
      placeOrder: "orders/create",
      allOrders: "orders",
      customerOrders: (userId: string) => `orders/user/${userId}`,
      orderById: (id: number) => `orders/${id}`,
      updateOrderStatus: (id: number, statusId: number) =>
        `orders/${id}/updateStatus/${statusId}`,
      markAsPaymentPaid: (id: number) => `orders/${id}/markAsPaid`,
      takePayment: (id: number) => `orders/${id}/takePayment`,
      getUserAddress: (id: string) => `orders/${id}/address`,
      refreshPaymentStatus: (orderId: number, id: string) =>
        `orders/${orderId}/refresh-payment-status/${id}`,
      createRefund: "orders/createRefund",
      refreshRefundStatus: (orderId: number) =>
        `orders/refreshRefundStatus/${orderId}`,
      assignDeliveryDriver: (orderId: number, driverId: number) =>
        `orders/${orderId}/assignDeliveryDriver/${driverId}`,
      updateOrderPrintStatus: (orderId: number) =>
        `orders/${orderId}/updateOrderPrintStatus`,
      ordersHub: "ordershub",
    },
    payment: {
      getCardToken: "payment/card-token",
    },
    shopSettings: {
      shopSettingsHub: "shopsettingshub",
      getShopSettings: (id: number) => `shop/settings/${id}`,
      updateShopSettings: (id: number) => `shop/settings/${id}/update`,
    },
    delivery: {
      fetchDrivers: "delivery/drivers",
      createDriver: "delivery/drivers/create",
      updateDriver: (id: number) => `delivery/drivers/${id}/update`,
      deleteDriver: (id: number) => `delivery/drivers/${id}/del`,
    },
    allergen: {
      fech: "allergens",
      create: "allergens/create",
      update: (id: number) => `allergens/${id}/update`,
      delete: (id: number) => `allergens/${id}/del`,
    },
    category: {
      fech: "productcategories",
      create: "productcategories/create",
      update: (id: number) => `productcategories/${id}/update`,
      delete: (id: number) => `productcategories/${id}/del`,
    },
    distance: {
      calculate: (pcode1: string, pcode2: string) =>
        `Distance/calculate?postcode1=${pcode1}&postcode2=${pcode2}`,
    },
    productOffer: {
      allOffers: `ProductsOffer`,
      liveOffers: `ProductsOffer/live-offers`,
      productOfferById: (id: number) => `ProductsOffer/${id}`,
      createProductOffer: "ProductsOffer/create",
      updateProductOffer: (id: number) => `ProductsOffer/${id}/update`,
      deleteProductOffer: (id: number) => `ProductsOffer/${id}/del`,
      offerHub: "offerhub",
    },
    voucher: {
      allVouchers: `Vouchers`,
      liveVouchers: `Vouchers/live-vouchers`,
      VoucherById: (id: number) => `Vouchers/${id}`,
      createVoucher: "Vouchers/create",
      updateVoucher: (id: number) => `Vouchers/${id}/update`,
      deleteVoucher: (id: number) => `Vouchers/${id}/del`,
      applyVoucher: (code: string) => `Vouchers/apply/${code}`,
      shareVoucher: (voucherId: number) => `Vouchers/${voucherId}/share`,
      shareVoucherWithAdmin: (voucherId: number) =>
        `Vouchers/${voucherId}/shareWithAdmin`,
      previewVoucherEmail: (voucherId: number) =>
        `Vouchers/${voucherId}/previewVoucherEmail`,
      // voucherHub: "voucherhub",
    },
  },
  DISTANCE_ROOT_URL: AppConfig?.DistanceApiBaseUrl ?? "",
};
